/**
 * A Date whose LOCAL fields are the given instant's UTC fields, so anything
 * formatting it in local time prints the instant's UTC wall clock.
 *
 * WHY. A date the server renders into the HTML is formatted in the server's
 * timezone, and the browser's hydrating render has to produce exactly the same
 * text or React throws the server's markup away and renders the page again.
 * Formatting this value gives every environment the same answer: the server and
 * a browser in Sydney both print the UTC date. Once hydrated, a page formats the
 * real instant (see useHydrated), so the visitor still ends up reading their own
 * local date. For a date shown without a time the two differ only in the hours
 * either side of midnight UTC.
 *
 * Built from the UTC fields rather than by adding the timezone offset, because
 * an offset is the browser's at one instant and can be an hour out across a
 * daylight-saving change, where the fields are the same everywhere. The one
 * thing the Date constructor still moves is a wall time that does not exist
 * locally (inside a daylight-saving gap), forward by the gap.
 */
export function utcWallClock(date: Date): Date {
  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds(),
    date.getUTCMilliseconds(),
  );
}
